module.exports = __webpack_public_path__ + "static/media/atlas.563993bc.jpg";